import ImageLoading from "../../../components/ImageLoading";
import AgGraph from "./AgGraph";

const SuccessfulRequestGraph = ({ tab, type, dates, fetch, loading }) => {
  return (
    <>
      {loading ? (
        <>
          <div className="flex w-full h-full justify-center items-center">
            <ImageLoading />
          </div>
        </>
      ) : (
        <>
          {" "}
          <div className=" pt-4 h-full">
            <div className="flex justify-between items-center mb-[22px] ml-4">
              <p className="text-[16px] font-semibold">
                {type === "success" ? "Successful Requests" : "Failed Requests"}
              </p>
            </div>
            <div className="  pl-[27.5px]">
              <AgGraph type={type} dates={dates} repayment={fetch} />
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default SuccessfulRequestGraph;
